import { locales } from '@monoimin/constants';

import type { Locales } from '@monoimin/sb-types';

export const passLocale = (locale: Locales, localesList = locales) => {
  return Boolean(localesList.find((item) => item === locale));
};

export default passLocale;
